import React, { useEffect, useState } from 'react';
import { Layout, Spin } from 'antd';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';

import * as actions from '../../../redux/actions/user';
// import Sidebar from '../../blocks/Sidebar';
import Header from '../../blocks/Header';
import { IState, IUserData } from '../../../types/interfaces';

import style from './pageLayout.module.scss';

interface IProps {
  children: JSX.Element;
  auth: boolean;
  setAuth: (payload: boolean) => void;
  setUserData: (payload: IUserData) => void;
  userData: IUserData;
}

const PageLayout: React.FC<IProps> = ({ children, auth, setAuth, setUserData, userData }: IProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const history = useHistory();

  useEffect(() => {
    (async () => {
      if (!auth) {
        setIsLoading(true);

        // При запуске на локалке нужно закомментировать данный блок

        // const url = new URL(window.location.href);
        // const pathParams = new URLSearchParams(url.search);
        // const sectionId = pathParams.get('section_id');
        // const unsuccessUrl = `/api/auth/etp-oauth2${sectionId ? `?section_id=${sectionId}` : ''}`;

        // ========================================================
        try {
          const res = await fetch('/api/auth/me', {
            headers: {
              'Cache-Control': 'no-cache, no-store, must-revalidate',
              Pragma: 'no-cache',
            },
          });
          if (res.status < 300 && res.status >= 200) {
            const result = await res.json();
            setUserData({ ...result.ownerData, sectionId: result.sectionId });
            setAuth(true);
            setIsLoading(false);
          } else {
            // При запуске на локалке нужно закомментировать строку с history.push
            // И расскоментировать строку с window.location.href

            history.push('/nonAuth');
            // window.location.href = unsuccessUrl;
          }
        } catch (error: any) {
          // При запуске на локалке нужно закомментировать строку с history.push
          // И расскоментировать строку с window.location.href

          history.push('/nonAuth');
          // window.location.href = unsuccessUrl;
        }
      }
    })();
  }, [setAuth, auth, setUserData, history]);

  useEffect(() => {
    const timeRedirect: number = 60000 * 30;
    setTimeout(() => {
      history.push('/nonAuth');
    }, timeRedirect);
  }, [history]);

  return (
    <div className={style.wrapper}>
      {isLoading ? (
        <div className={style.spin}>
          <Spin />
        </div>
      ) : (
        <Layout className={style.layoutFill}>
          <Layout className={style.layout}>
            <Header ownerData={userData} setAuthLogout={setAuth} setUserDataLogout={setUserData} />
            {children}
          </Layout>
        </Layout>
      )}
    </div>
  );
};

const mapStateToProps = (state: IState) => ({
  auth: state.user.isAuth,
  userData: state.user.userData,
});

export default connect(mapStateToProps, actions)(PageLayout);
